import { mergeWithArrayOverride } from '@yimoka/shared';
import { ConfigProvider } from 'antd';
import { useContext } from 'react';

import { Locale } from '../../public/locale/type';

const defaultLocale: Locale = {
  locale: 'en_US',
  Common: { confirm: 'Confirm', cancel: 'Cancel', submit: 'Submit', reset: 'Reset' },
  Exception: {
    backHome: 'Back home',
    retry: 'Try again',
    errorTitle: 'An error occurred',
    forbidden: 'Sorry, you are not authorized to access this page',
    notFound: 'Sorry, the page you visited does not exist',
    serverError: 'Sorry, the server encountered an error',
  },
  ListFilter: { query: 'Query', reset: 'Reset' },
  RecordDel: { popconfirmTitle: 'Are you sure to delete?', popconfirmDescription: 'This action cannot be undone', text: 'Delete' },
  RecordEnable: { popconfirmTitle: 'Are you sure to enable?', text: 'Enable' },
  RecordDisable: { popconfirmTitle: 'Are you sure to disable?', text: 'Disable' },
  RecordBatchDel: { popconfirmTitle: 'Are you sure to delete?', popconfirmDescription: 'This action cannot be undone', text: 'Batch Delete' },
  RecordBatchEnable: { popconfirmTitle: 'Are you sure to enable?', text: 'Batch Enable' },
  RecordBatchDisable: { popconfirmTitle: 'Are you sure to disable?', text: 'Batch Disable' },
  StoreTable: { total: (total: number) => `Total ${total} records`, itemsPerPage: '/ page' },
  UploadS3: { upload: 'Upload' },
  YimokaImage: { empty: 'No image' },
  InImage: {
    delete: 'Delete',
    inputAddress: 'Enter URL',
    viewAddress: 'View URL',
    inputTitle: 'Enter image URL',
    inputPlaceholder: 'Enter image URL',
    viewTitle: 'View image URL',
  },
  PrefixPhoneSelect: { placeholder: 'Enter phone number', countryNameField: 'english_name' },
  I18nEditor: {
    confirm: 'Confirm',
    title: 'Translations',
    help: 'Empty content uses the default field value. Remember to submit after confirming the content.',
    addLanguage: 'Add language',
    selectLanguage: 'Select a language',
    languageExists: 'This language already exists',
  },
};

export const useLocaleComponent = <T extends keyof Locale>(component: T) => {
  const context = useContext(ConfigProvider.ConfigContext);
  const locale = (context.locale ?? {}) as Locale;
  return mergeWithArrayOverride({}, defaultLocale[component], locale[component]) as (Required<Locale>[T]);
};
